<!-- Chat.vue -->
<template>
  <div
    class="chat-container bl-blue-cs bb-blue-cs"
    :class="!isFloating ? 'min-vh-100' : ''"
  >
    <div class="chat-header">
      <div class="fw-700 fz-20 text-title text-white">
        {{ $t("Customer Service") }}
      </div>
      <div class="fw-400 fz-14 text-subtitle text-white">
        {{ $t("Hello there, we are glad to help you") }}
      </div>
    </div>

    <div
      class="category-tabs d-flex w-100 br-blue-cs"
    >
      <div
        class="w-100 m-0 text-center"
        :class="nav == 'category' ? 'active' : ''"
        @click="changeNav('category')"
      >
        {{ $t("Category") }}
      </div>
      <div
        class="w-100 m-0 text-center"
        :class="nav == 'history' ? 'active' : ''"
        @click="changeNav('history')"
      >
        {{ $t("History") }}
      </div>
    </div>

    <chat-body
      ref="chat-body"
      :isFloating="isFloating"
      @is-connect="isConnect"
      @push-chat-list="pushChatList"
      @show-loader="showLoader"
      @set-category="setCategory"
      @chat-list="setChatList"
    ></chat-body>
  </div>
</template>

<script>
import ChatBody from "@/components/Chat/ChatBody";
import Maintenance from "@/components/Maintenance";
export default {
  data() {
    return {
      nav: "category"
    };
  },
  props: ["isFloating"],
  components: {
    ChatBody,
    Maintenance,
  },
  methods: {
    isConnect(bool) {
      this.$emit("is-connect", bool);
    },
    captureFile(event) {
      this.$refs["chat-body"].captureFile(event);
    },
    sendMessage(message) {
      this.$refs["chat-body"].sendMessage(message);
    },
    setCategory(category) {
      this.$emit("set-category", category);
    },
    changeNav(nav) {
      this.nav = nav;
      this.$refs["chat-body"].changeNav(nav);
    },
    setChatList(data) {
      this.$emit("chat-list", data);
    },
    showLoader(param) {
      this.$emit("show-loader", param);
    },
    pushChatList(param) {
      this.$emit("push-chat-list", param);
    },
  },
  created() {
    const theme =
      process.env.VUE_APP_THEME != "" && process.env.VUE_APP_THEME != 1
        ? process.env.VUE_APP_THEME
        : "default";
    require(`@/assets/css/${theme}/chat.css`);
  },
};
</script>
